import { Accordion } from "primereact/accordion";
import * as React from "react";
import { useEffect, useState } from "react";
import "./PrwcAccordion.scss";

const PrwcAccordion = (props: any) => {
  const { activeIndex = [0], multiple = true } = props;
  const [activeTabs, setActiveTabs] = useState(activeIndex);

  useEffect(() => {
    setActiveTabs(activeIndex);
  }, [activeIndex]);

  const handleTabChange = (activeTabs: any) => {
    props.changeActiveTabs(activeTabs);
  };

  return (
    <Accordion
      multiple={multiple}
      activeIndex={activeTabs}
      onTabChange={(e) => handleTabChange(e.index)}
    >
      {props.children}
    </Accordion>
  );
};

export default PrwcAccordion;
